import {
	Briefcase,
	Building,
	BookOpen,
	CalendarDays,
	ClipboardList,
	FolderOpen,
	GraduationCap,
	HeartHandshake,
	HouseHeart,
	type LucideIcon,
	MessagesSquare,
	NotebookPen,
	UserRound,
} from 'lucide-react';

/** Icon component of each icon value the server sends for a subject type. */
const subjectTypeIcons: Readonly<Record<string, LucideIcon>> = Object.freeze({
	folder: FolderOpen,
	notebook: NotebookPen,
	clipboard: ClipboardList,
	briefcase: Briefcase,
	graduation: GraduationCap,
	house: HouseHeart,
	building: Building,
	calendar: CalendarDays,
	meeting: MessagesSquare,
	person: UserRound,
	support: HeartHandshake,
	book: BookOpen,
});

export default subjectTypeIcons;
